export default __webpack_public_path__ + "static/media/4 raw.0e277f95.mp3";